import * as Yup from "yup";

export const validationSchema = Yup.object().shape({
	message: Yup.string().required(),
});
